module.exports = __webpack_public_path__ + "post-listing-block-4-overlay-1DqwrkN.png";